// Thin API client for the entitlements endpoints in rd.
// Uses the shared RequestBuilder for auth + retry + msgpack handling.

import { RequestBuilder, toJSON } from "./request";

const BASE = "/api/admin/entitlements";
const ME_BASE = "/api/me/entitlements";

// NOTE: RequestBuilder.fetch() resolves to the raw Response on success — every
// query module must chain `.then(toJSON)` to get the parsed body. Omitting it
// (as this module originally did) returns a Response, so callers reading
// `resp.content`/`resp.features` got undefined and silently saw empty data.

export const fetchMyEntitlements = (authData) =>
  new RequestBuilder(ME_BASE)
    .withAuthorization(authData)
    .withJSONContentType()
    .fetch()
    .then(toJSON);

export const fetchTenantEntitlements = (authData) =>
  new RequestBuilder(BASE)
    .withAuthorization(authData)
    .withJSONContentType()
    .fetch()
    .then(toJSON);

export const grantEntitlement = (authData, payload) =>
  new RequestBuilder(BASE)
    .withAuthorization(authData)
    .withJSONContentType()
    .asPOST(JSON.stringify(payload))
    .fetch()
    .then(toJSON);

export const revokeEntitlement = (authData, userId, feature) =>
  new RequestBuilder(`${BASE}/${encodeURIComponent(userId)}/${encodeURIComponent(feature)}`)
    .withAuthorization(authData)
    .asDELETE()
    .fetch()
    .then(toJSON);
